/**
 * Get the appropriate YouTube channel link based on user region
 * @param region - The user's region code
 * @returns YouTube channel URL with subscription confirmation
 */
export function getYouTubeRegionLink(region?: string): string {
  if (!region) {
    return 'https://www.youtube.com/@angelstudiosinc?sub_confirmation=1'
  }

  const upperRegion = region.toUpperCase()

  switch (upperRegion) {
    case 'IT':
      return 'https://www.youtube.com/@AngelStudiosItalia?sub_confirmation=1'
    case 'GR':
    case 'CY':
      return 'https://www.youtube.com/@AngelGreece?sub_confirmation=1'
    case 'AU':
    case 'NZ':
    case 'FJ':
    case 'PG':
    case 'WS':
    case 'TO':
    case 'VU':
    case 'SB':
    case 'KI':
    case 'TV':
    case 'NR':
    case 'PW':
    case 'MH':
    case 'FM':
    case 'PF':
    case 'NC':
    case 'NU':
    case 'TK':
    case 'WF':
    case 'NF':
      return 'https://www.youtube.com/@AngelStudiosANZ?sub_confirmation=1'
    case 'KR':
      return 'https://www.youtube.com/@AngelStudiosKorea?sub_confirmation=1'
    case 'GB':
    case 'IE':
      return 'https://www.youtube.com/@AngelStudiosUK?sub_confirmation=1'
    case 'RS':
    case 'HR':
    case 'SI':
    case 'BA':
    case 'ME':
      return 'https://www.youtube.com/@AngelExYugo?sub_confirmation=1'
    case 'PL':
      return 'https://www.youtube.com/@AngelStudiosPoland?sub_confirmation=1'
    case 'IN':
    case 'LK':
      return 'https://www.youtube.com/@AngelStudiosIndia?sub_confirmation=1'
    case 'PH':
      return 'https://www.youtube.com/@AngelPhilippines?sub_confirmation=1'
    case 'BR':
      return 'https://www.youtube.com/@AngelStudiosBrasil?sub_confirmation=1'
    case 'ES':
      return 'https://www.youtube.com/@AngelStudiosEspa%C3%B1a?sub_confirmation=1'
    case 'AR':
    case 'AW':
    case 'BZ':
    case 'BO':
    case 'CL':
    case 'CO':
    case 'CR':
    case 'CU':
    case 'CW':
    case 'DO':
    case 'EC':
    case 'FK':
    case 'GS':
    case 'GT':
    case 'GY':
    case 'HN':
    case 'JM':
    case 'MX':
    case 'NI':
    case 'PA':
    case 'PE':
    case 'PY':
    case 'SV':
    case 'TT':
    case 'UY':
    case 'VE':
      return 'https://www.youtube.com/@AngelStudiosLATAM?sub_confirmation=1'
    case 'TW':
      return 'https://www.youtube.com/@AngelTaiwan?sub_confirmation=1'
    case 'DE':
    case 'AT':
    case 'CH':
      return 'https://www.youtube.com/@AngelStudiosDACH?sub_confirmation=1'
    case 'AE':
    case 'AO':
    case 'BD':
    case 'BF':
    case 'BJ':
    case 'BI':
    case 'BS':
    case 'BW':
    case 'CD':
    case 'CF':
    case 'CG':
    case 'CI':
    case 'CM':
    case 'CV':
    case 'CX':
    case 'DJ':
    case 'DM':
    case 'DZ':
    case 'EG':
    case 'ER':
    case 'ET':
    case 'GA':
    case 'GH':
    case 'GM':
    case 'GN':
    case 'GQ':
    case 'GW':
    case 'KE':
    case 'KM':
    case 'LB':
    case 'LR':
    case 'LS':
    case 'LY':
    case 'MA':
    case 'MG':
    case 'ML':
    case 'MR':
    case 'MU':
    case 'MW':
    case 'MZ':
    case 'NA':
    case 'NE':
    case 'NG':
    case 'RW':
    case 'SA':
    case 'SC':
    case 'SG':
    case 'SJ':
    case 'SL':
    case 'SN':
    case 'SO':
    case 'SS':
    case 'ST':
    case 'SX':
    case 'SZ':
    case 'TD':
    case 'TG':
    case 'TZ':
    case 'UG':
    case 'ZA':
    case 'ZM':
    case 'ZW':
      return 'https://www.youtube.com/@AngelStudiosAfrica?sub_confirmation=1'
    case 'BE':
    case 'NL':
    case 'LU':
      return 'https://www.youtube.com/@AngelBENELUX?sub_confirmation=1'
    case 'PT':
      return 'https://www.youtube.com/@AngelStudiosPortugal?sub_confirmation=1'
    case 'FR':
      return 'https://www.youtube.com/@AngelStudiosFrance?sub_confirmation=1'
    case 'IL':
      return 'https://www.youtube.com/@AngelStudiosIsrael?sub_confirmation=1'
    default:
      return 'https://www.youtube.com/@angelstudiosinc?sub_confirmation=1'
  }
}
